import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Building2, AlertCircle } from "lucide-react";

export function BankingDetailsSection() {
  const form = useFormContext();

  return (
    <div className="space-y-6 animate-fade-up">
      <Card>
        <CardContent className="pt-6">
          <div className="grid gap-6 md:grid-cols-2">
            {/* BSB Field */}
            <FormField
              control={form.control}
              name="bsb"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>BSB Number</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="123-456"
                      className="bg-background"
                      {...field}
                      maxLength={6}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d]/g, '');
                        field.onChange(value);
                      }}
                    />
                  </FormControl>
                  <FormDescription>
                    6-digit BSB number without hyphen
                  </FormDescription>
                  <FormMessage />
                </FormItem>
              )}
            />

            {/* Account Number Field */}
            <FormField
              control={form.control}
              name="account_number"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Account Number</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="12345678"
                      className="bg-background"
                      {...field}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d]/g, '');
                        field.onChange(value);
                      }}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            {/* Account Name Field */}
            <FormField
              control={form.control}
              name="account_name"
              render={({ field }) => (
                <FormItem className="md:col-span-2">
                  <FormLabel>Account Name</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="John Doe"
                      className="bg-background"
                      {...field}
                    />
                  </FormControl>
                  <FormDescription>
                    Name as it appears on your bank account
                  </FormDescription>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </CardContent>
      </Card>

      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Secure Banking</AlertTitle>
        <AlertDescription>
          Your banking details are protected with bank-level security and encryption.
          We follow strict Australian banking regulations to ensure your information
          is safe.
        </AlertDescription>
      </Alert>
    </div>
  );
}